module.exports = __webpack_public_path__ + "assets/img/serve4.97b5bee5.png";